import { useContext } from "react";
import { base, brandInfo } from "../../../constant";
import { useLogin } from "./hooks";
import { useElement, useLocale, useService, useWidget } from "../../../hooks";
import { AppContext } from "../../../context";

export const Login = () => {
  const { selectors: { getLogo } } = useContext(AppContext);
  const logo = getLogo() || brandInfo.logo;
  const { t } = useLocale();
  const Img = useElement("Img");
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Input = useElement("Input");
  const SocialButton = useWidget("SocialButton");
  const {
    sendOtp,
    handleSocialLogin,
    handleSocialLoginFailure,
    navigateToHome,
    setMobileNumber,
    mobileNumber,
  } = useLogin();
  const { isModuleEnabled } = useService("Misc");

  return (
    <div className="login-page">
      <div className="left-box-login left-box-login-login"></div>
      <div className="body-background flex">
        <div className="mauto p30 max-width-loginBox tac">
          <Link href="/" className="logo">
            <Img
              source="internal"
              alt={brandInfo.name.capital}
              className="logo-right-banner"
              src={logo}
            />
          </Link>
          <p className="welcomText">{t("loginHeading")}</p>
          <div className="loginIcon">
            <i className="hi-call"></i>
          </div>
          <h1 className="form-title tac">{t("loginWithMobile")}</h1>
          <form onSubmit={sendOtp} noValidate>
            <div className="form-group">
              <Input
                autoFocus
                value={mobileNumber}
                onChange={setMobileNumber}
                className="input"
                type="number"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength={10}
                minLength={10}
                max={9999999999}
                min={1000000000}
              />
            </div>
            <Button className="btn btn-primary width-full" type="submit">
              {t("submit")}
            </Button>
          </form>
          {isModuleEnabled(["SocialLogin"]) && (
            <div className="social-media-box mv20">
              <p>{t("or")}</p>
              <ul>
                <li className="fb-logo">
                  <SocialButton
                    provider="facebook"
                    appId={base.fbAppId}
                    onLoginSuccess={handleSocialLogin}
                    onLoginFailure={handleSocialLoginFailure}
                  >
                    <Img
                      source="internal"
                      src={require("../../../../assets/images/btn_fb.png")}
                      alt="Login with facebook"
                    />
                  </SocialButton>
                  <SocialButton
                    provider="google"
                    appId={base.googleSignInCleintId}
                    onLoginSuccess={handleSocialLogin}
                    onLoginFailure={handleSocialLoginFailure}
                  >
                    <Img
                      source="internal"
                      src={require("../../../../assets/images/btn_google.png")}
                      alt="Sign with google"
                    />
                  </SocialButton>
                </li>
              </ul>
            </div>
          )}
        </div>
        <i
          className="hi-arrow-circle-left footer-back-btn"
          onClick={navigateToHome}
        ></i>
      </div>
    </div>
  );
};
